import React, { ReactNode, createContext} from "react";
import { endPointStoreData } from "modules/main/services/endpoints";
import { StoreData } from "modules/main/types/storeData";
import { useFetch } from "../hooks/useFetch";
import { Navigate } from "react-router-dom";



interface AppDataProviderProps {
    children: ReactNode;
}

interface AppDataContextType {
    storeList: StoreData[];
}

export const AppDataProvider:React.FC<AppDataProviderProps>  = ({children}) => {      
    // const [storeList,setStoreList] = useState<StoreData[]>([]);
    const {data,error}  = useFetch<StoreData[]>(endPointStoreData);
    // const ErrorComponent = (error instanceof AuthError) ? NoAuthError : GeneralError;
    const storeList = data?data:[];
    
    // useEffect(()=>{
    //     const fetchDataAsync = async () => {
    //         try{
    //             const dataStoreApi = fetchData(endPointStoreData);  

    //             const data:StoreData[] = dataStoreApi.read() 
    //             console.log(data);
    //             setStoreList(data);
    //         }catch(error){
    //             console.log("Error", error);
    //         }
    //     }
    //     fetchDataAsync();
    // },[]);

    return ( 
        <AppDataContext.Provider value={
            {storeList}
        }>
            {children}
        </AppDataContext.Provider>
    )

}

export const AppDataContext = createContext<AppDataContextType>({storeList:[]});
